/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";

import { Modal, Container, Row, Col } from "reactstrap";
import { ModalSave } from "../modals/modalSave";
import { ModalPreview } from "../modals/modalPreview";
import { ModalConfirmRemove } from ".";
import { configuration } from "./configuration";
import { useTranslation } from "react-i18next";

import "../../Styles/modules/_modalVersionSelector.scss";

import {
  fetchThemes,
  deleteTheme,
  renameTheme,
  duplicateTheme,
  addNewTheme,
} from "../../api";

export const ModalTemplate = ({
  isOpen,
  onClose,
  onSelectTemplate,
  currentTemplateID,
  userType,
  storeKey,
}) => {
  const options = { year: "numeric", month: "long", day: "numeric" };

  const { t } = useTranslation();

  const [tableData, setTableData] = useState(null); // Table data
  const [isShowingSaveAs, setIsShowingSaveAs] = useState(false); // Saving Modal
  const [isShowingRename, setIsShowingRename] = useState(false); // Rename Modal
  const [isShowingDelete, setIsShowingDelete] = useState(false); // Delete Modal
  const [isShowingPreview, setIsShowingPreview] = useState(false); // Preview Modal
  const [isShowingCreateTheme, setIsShowingCreateTheme] = useState(false); // Create Theme Modal
  const [selectedKey, setSelectedKey] = useState(null);
  const [dataUpdateCount, setDataUpdateCount] = useState(0);

  const customLoaderJson = `{"v":"5.5.5","fr":25,"ip":0,"op":79,"w":300,"h":150,"nm":"Loading-2","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"icon 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":39,"s":[-90]},{"t":79,"s":[270]}],"ix":10},"p":{"a":0,"k":[150,75,0],"ix":2},"a":{"a":0,"k":[53,53,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-15.464],[15.464,0],[0,15.464],[-15.464,0]],"o":[[0,15.464],[-15.464,0],[0,-15.464],[15.464,0]],"v":[[28,0],[0,28],[-28,0],[0,-28]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.09411764705882353,0.4196078431372549,0.984313725490196,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[53,53],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":51,"s":[0]},{"t":79,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":39,"s":[0]},{"t":64,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":39,"op":79,"st":39,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"icon","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[-90]},{"t":40,"s":[270]}],"ix":10},"p":{"a":0,"k":[150,75,0],"ix":2},"a":{"a":0,"k":[53,53,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-15.464],[15.464,0],[0,15.464],[-15.464,0]],"o":[[0,15.464],[-15.464,0],[0,-15.464],[15.464,0]],"v":[[28,0],[0,28],[-28,0],[0,-28]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.09411764705882353,0.4196078431372549,0.984313725490196,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[53,53],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":12,"s":[0]},{"t":40,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":25,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":40,"st":0,"bm":0}],"markers":[]}`

  // Template data
  const [templateData, setTemplateData] = useState({
    templateID: null,
    name: null,
  });

  const shouldDisableButton = () => {
    // Subtract 2 from themeCount because there are always 2 extra entries
    const themeCount = tableData ? Object.keys(tableData).length - 2 : 0;

    // Mapping the new user types to the corresponding groups
    const userTypeMapping = {
      monthly1: "paid1",
      yearly1: "paid1",
      monthly2: "paid2",
      yearly2: "paid2",
    };

    // Determine the group for the current user type
    const userGroup = userTypeMapping[userType] || userType;

    switch (userGroup) {
      case "paid1":
        // For 'paid1' users, check if themeCount exceeds 2
        return themeCount > 1;
      case "paid2":
        // For 'paid2' users, check if themeCount exceeds 5
        return themeCount > 4;
      default:
        // For 'trial', 'monthly3', 'yearly3' and other user types, no restriction
        return false;
    }
  };

  useEffect(() => {
    fetchData();
  }, [dataUpdateCount]);

  const fetchData = async () => {
    setTableData(null);

    // API
    fetchThemes(storeKey)
      .then((response) => {
        const data = response.data;
        if (data) {
          setTimeout(() => {
            setTableData(data); // Update table data
          }, 500);
        }
      })
      .catch((error) => {
        console.error("Error fetching navBar data:", error);
      });
  };

  const doDeleteTheme = () => {
    // API
    deleteTheme(storeKey, selectedKey)
      .then((response) => {
        setSelectedKey(null); // Reset the selectedKey state
        setIsShowingDelete(false);
        setDataUpdateCount((prevCount) => prevCount + 1);
      })
      .catch((error) => {
        console.error("Error delete Theme:", error);
      });
  };

  const doRenameTheme = (newName) => {
    if (newName.length > 3) {
      // API
      renameTheme(storeKey, selectedKey, newName)
        .then((response) => {
          setSelectedKey(null); // Reset the selectedKey state
          setIsShowingRename(false); // Close the modal
          setDataUpdateCount((prevCount) => prevCount + 1);
        })
        .catch((error) => {
          console.error("Error renameTheme:", error);
        });
    } else {
      console.error("Name length < 3");
    }
  };

  const saveAsTheme = (newName) => {
    if (newName.length > 3) {
      // API
      duplicateTheme(storeKey, selectedKey, newName)
        .then((response) => {
          setSelectedKey(null); // Reset the selectedKey state
          setIsShowingSaveAs(false); // Close the modal
          setDataUpdateCount((prevCount) => prevCount + 1);
        })
        .catch((error) => {
          console.error("Error renameTheme:", error);
        });
    } else {
      console.error("Name lenght < 3");
    }
  };

  const createTheme = (name) => {
    if (name.length > 3) {
      addNewTheme(storeKey, name, configuration)
        .then((response) => {
          setSelectedKey(null);
          setIsShowingCreateTheme(false);
          // Espera 1 segundo antes de actualizar la data
          setTimeout(() => {
            setDataUpdateCount((prevCount) => prevCount + 1);
          }, 500);
        })
        .catch((error) => {
          console.error("Error en createTheme:", error);
        });
    } else {
      console.error("Name length < 3");
    }
  };

  const handleCreateEmptyTheme = (key) => {
    setIsShowingCreateTheme(true);
  };

  const handleDelete = (key) => {
    setSelectedKey(key);
    setIsShowingDelete(true);
  };

  const handleSaveAs = (key) => {
    setSelectedKey(key);
    setIsShowingSaveAs(true);
  };

  const handleRename = (key) => {
    setSelectedKey(key);
    setIsShowingRename(true);
  };

  const handlePreview = (templateID, name) => {
    setTemplateData({ templateID: templateID, name: name });
    setIsShowingPreview(true);
  };

  const handleSelectTemplate = (templateID, name) => {
    onSelectTemplate(templateID, name);
    onClose();
  };

  const getLoaderAnimation = (customLoaderJson) => {
    return JSON.parse(customLoaderJson);
};

const LoaderAnimattion = (props) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: getLoaderAnimation(
      props.customLoaderJson
    ),
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const animationStyle = {
    margin: "250px auto auto 280px",
    zIndex: 5000,
  };

  return (
    <Lottie
      options={defaultOptions}
      height={"200px"}
      width={"200px"}
      style={animationStyle}
    />
  );
};

  return (
    <Modal
      isOpen={isOpen}
      className="transitionSelector preview modalVersion isOpen"
      size="xl"
    >
      {isShowingDelete && (
        <ModalConfirmRemove
          isOpen={isShowingDelete}
          onConfirm={doDeleteTheme}
          onCancel={() => {
            setIsShowingDelete(false);
            setSelectedKey(null); // Reset the selectedKey state
          }}
        />
      )}
      {isShowingSaveAs && (
        <ModalSave
          isOpen={isShowingSaveAs}
          onConfirm={saveAsTheme}
          onClose={() => {
            setIsShowingSaveAs(false);
            setSelectedKey(null); // Reset the selectedKey state
          }}
        />
      )}
      {isShowingRename && (
        <ModalSave
          isOpen={isShowingRename}
          onConfirm={doRenameTheme}
          onClose={() => {
            setIsShowingRename(false);
            setSelectedKey(null); // Reset the selectedKey state
          }}
        />
      )}
      {isShowingCreateTheme && (
        <ModalSave
          isOpen={isShowingCreateTheme}
          onConfirm={createTheme}
          onClose={() => {
            setIsShowingCreateTheme(false);
          }}
        />
      )}
      {isShowingPreview && (
        <ModalPreview
          isOpen={isShowingPreview}
          onClose={() => setIsShowingPreview(false)}
          templateID={templateData.templateID}
          templateName={templateData.name}
          storeKey={storeKey}
        />
      )}
      <section>
        <div className="modal__container">
          <div className="row" style={{ marginBottom: "-40px" }}>
            <div className="modal__title primary">Themes</div>
            <div className="modal__buttons__themes">
              <button
                type="button"
                className="close__button custom-button-theme addtheme-button"
                onClick={() => handleCreateEmptyTheme()}
                disabled={shouldDisableButton()}
                style={{ opacity: shouldDisableButton() ? 0.5 : 1 }}
              >
               {t("homeModalTemplate.buttonAddNewTheme")}
              </button>
              <button
                type="button"
                className="close__button custom-button-theme cancel-button"
                onClick={onClose}
              >
                {t("buttons.close")}
              </button>
            </div>
          </div>
          <div className="body__modal row">
            <thead className="table__head">
              <tr>
                <th className="head__th" style={{ width: "440px" }}>
                {t("homeModalTemplate.copyName")}
                </th>
                <th className="head__th__update">{t("homeModalTemplate.copyCreated")}</th>
              </tr>
            </thead>

            <div className="body__background">
              <table
                className="table row"
                style={{ overflowY: "scroll", height: "520px" }}
              >
                <tbody className="table__body ">
                  {tableData ? (
                    Object.entries(tableData).map(([key, value]) => {
                      if (key !== "selectedConfig" && key !== "currentConfig") {
                        return (
                          <tr className="table__body--tr title__container">
                            <td className="text-uppercase item__title theme__container">
                              {value.name}
                            </td>
                            {(key === tableData.selectedConfig ||
                              currentTemplateID == key) && (
                              <td className="text-uppercase item__title span__container">
                                {key === tableData.selectedConfig && (
                                  <span>{t("homeModalTemplate.copyPublic")}</span>
                                )}
                                {currentTemplateID == key && (
                                  <div className="container_span">
                                    <span className="centered_span">
                                    {t("homeModalTemplate.copySelectedTheme")}
                                    </span>
                                  </div>
                                )}
                              </td>
                            )}

                            <td className="day__container">
                              {" "}
                             {new Date(+value.nameDate).toLocaleDateString("en-US")}
                            </td>
                            <td className="buttons__container preview">
                              <button
                                type="button"
                                className="buttonComponent edit"
                                onClick={() =>
                                  handleSelectTemplate(key, value.name)
                                }
                              >
                                {t("homeModalTemplate.buttonEdit")}
                              </button>

                              <button
                                type="button"
                                className=" buttonComponent preview"
                                onClick={() => handleRename(key)}
                              >
                                {t("homeModalTemplate.buttonRename")}
                              </button>

                              <button
                                type="button"
                                className=" buttonComponent duplicate"
                                onClick={() => handleSaveAs(key)}
                                disabled={shouldDisableButton()}
                                style={{
                                  opacity: shouldDisableButton() ? 0.5 : 1,
                                }}
                              >
                                {t("homeModalTemplate.buttonDuplicate")}
                              </button>
                              <button
                                type="button"
                                className=" buttonComponent previewBlue"
                                onClick={() => handlePreview(key, value.name)}
                              >
                                {t("homeModalTemplate.buttonPreview")}
                              </button>
                              <button
                                type="button"
                                className=" buttonComponent delete"
                                style={{
                                  opacity:
                                    currentTemplateID !== key &&
                                    key !== tableData.selectedConfig
                                      ? 1
                                      : 0.5,
                                  pointerEvents:
                                    currentTemplateID !== key &&
                                    key !== tableData.selectedConfig
                                      ? "auto"
                                      : "none",
                                }}
                                onClick={() => {
                                  if (
                                    currentTemplateID !== key &&
                                    key !== tableData.selectedConfig
                                  )
                                    handleDelete(key);
                                }}
                              >
                                {t("homeModalTemplate.buttonDelete")}
                              </button>
                            </td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <div className="loading-content-theme ">
                      <div className="loading-container-theme">
                      <LoaderAnimattion
      selectedLoader={true}
      customLoaderJson={customLoaderJson}
    />
                      </div>                     
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Modal>
  );
};
